"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NumberInput = _interopRequireDefault(require("./NumberInput"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CurrencyInput = function CurrencyInput(_ref) {
  var name = _ref.name,
      value = _ref.value,
      _onChange = _ref.onChange,
      disabled = _ref.disabled,
      placeholder = _ref.placeholder,
      rest = _objectWithoutProperties(_ref, ["name", "value", "onChange", "disabled", "placeholder"]);

  var ValidateOnChange = function ValidateOnChange(onChange, newValue) {
    if (newValue && newValue.length > 1) {
      newValue = newValue.replace(/^0+/, "");

      if (newValue.includes(".")) {
        var split = newValue.split(".");

        if (split.length === 2) {
          if (split[1].length <= 2) {
            onChange(newValue);
          }
        } else if (split.length <= 1) {
          onChange(newValue);
        }
      } else {
        onChange(newValue);
      }
    } else {
      onChange(newValue);
    }
  };

  return _react["default"].createElement("div", {
    className: "input-group"
  }, _react["default"].createElement("div", {
    className: "input-group-prepend"
  }, _react["default"].createElement("span", {
    className: "input-group-text"
  }, "$")), _react["default"].createElement(_NumberInput["default"], _extends({
    id: name,
    onChange: function onChange(value) {
      return ValidateOnChange(_onChange, value);
    },
    value: value,
    disabled: disabled,
    placeholder: placeholder,
    step: 0.01
  }, rest)));
};

CurrencyInput.propTypes = {
  /** value to pass */
  value: _propTypes["default"].any.isRequired,

  /** on change callback */
  onChange: _propTypes["default"].func.isRequired,

  /** name of the input */
  name: _propTypes["default"].string,

  /** placeholder of the input */
  placeholder: _propTypes["default"].string,

  /** if the input is disabled */
  disabled: _propTypes["default"].bool
};
CurrencyInput.defaultProps = {
  className: "",
  name: "best-currency-input",
  placeholder: "amount",
  disabled: false
};
var _default = CurrencyInput;
exports["default"] = _default;